/* eslint-disable import/prefer-default-export */
export const CONTACT_TYPES = {
  RATIFICATION: 'RATIFICATION',
  COLLECTION: 'COLLECTION',
  COMMERCIAL: 'COMMERCIAL',
  COMMERCIAL_KEY: 'COMMERCIAL_KEY',
  PREOFFER_COMMERCIAL_KEY: 'PREOFFER_COMMERCIAL_KEY',
};
